export default __webpack_public_path__ + "static/media/donation.35df62d9.svg";